import { create } from 'zustand';
import { ContactPropertyVisibleData } from '../dto/EntityRepository';
import type { ResourceStatus } from '../util/scopedResource';

interface ContactPropertyVisibleState {
  contactPropertyVisible: ContactPropertyVisibleData | null;
  visibleOwnerAui: string | null;
  status: ResourceStatus;
  beginContactPropertyVisibleFetch: (ownerAui: string) => void;
  setContactPropertyVisible: (value: ContactPropertyVisibleData, ownerAui: string) => void;
  setContactPropertyVisibleError: () => void;
  clearContactPropertyVisible: () => void;
}

const isSameContactPropertyVisible = (
  prev: ContactPropertyVisibleData | null,
  next: ContactPropertyVisibleData,
): boolean => {
  if (!prev) return false;
  return (
    prev.id === next.id &&
    prev.address === next.address &&
    prev.email === next.email &&
    prev.contact === next.contact &&
    prev.twitter === next.twitter &&
    prev.instagram === next.instagram &&
    prev.facebook === next.facebook &&
    prev.youtube === next.youtube &&
    prev.url1 === next.url1
  );
};

export const useContactPropertyVisibleStore = create<ContactPropertyVisibleState>((set) => ({
  contactPropertyVisible: null,
  visibleOwnerAui: null,
  status: 'idle',
  beginContactPropertyVisibleFetch: (ownerAui) => set((state) => {
    if (
      state.visibleOwnerAui === ownerAui &&
      state.status === 'success'
    ) {
      return state;
    }
    return { status: 'loading' };
  }),
  setContactPropertyVisible: (value, ownerAui) =>
    set((state) => {
      if (
        state.status === 'success' &&
        state.visibleOwnerAui === ownerAui &&
        isSameContactPropertyVisible(state.contactPropertyVisible, value)
      ) {
        return state;
      }
      return {
        contactPropertyVisible: value,
        visibleOwnerAui: ownerAui,
        status: 'success',
      };
    }),
  setContactPropertyVisibleError: () => set({ status: 'error' }),
  clearContactPropertyVisible: () => set((state) => {
    if (
      state.contactPropertyVisible === null &&
      state.visibleOwnerAui === null &&
      state.status === 'idle'
    ) {
      return state;
    }
    return {
      contactPropertyVisible: null,
      visibleOwnerAui: null,
      status: 'idle',
    };
  }),
}));
